<script>
    import FillInformation from '@/online_booking/new/components/common_booking/FillInformation.vue';
    import VoucherPurchaseSuccess from '@/online_booking/new/components/vouchers/VoucherPurchaseSuccess.vue';
    import ChooseVoucher from '@/online_booking/new/components/vouchers/ChooseVoucher.vue';
    import Payment from '@/online_booking/new/components/common_booking/Payment.vue';
    import ConfirmBooking from '@/online_booking/new/components/common_booking/ConfirmBooking.vue';
    import Login from '@/online_booking/new/components/Login.vue';
    import LoginCode from '@/online_booking/new/components/LoginCode.vue';
    import SignUp from '@/online_booking/new/components/SignUp.vue';
    import ChooseLoginUser from '@/online_booking/new/components/ChooseLoginUser.vue';
    import ChooseUser from '@/online_booking/new/components/ChooseUser.vue';
    import ChooseLoginOrSignup from '@/online_booking/new/components/ChooseLoginOrSignup.vue';
    import OnlineBookingSidebarSteps from '@/online_booking/new/components/common/OnlineBookingSidebarSteps.vue';
    import { http } from '@/system/http.js'
    import { mapActions } from 'vuex';
    import { bookingModules } from '@/online_booking/new/helpers/constants';

    export default {

        data: function () {
            return {
                showConfirmation: false,
                codeSent: false,
                online_booking_settings: null,
                user: null,
                requiredLogin: false,
                logged_in_client: false,
                loading: false,
                permalink: permalink,
                gmaps_url: null,
                paragraphHeight: 0,
                loginDesc: null,
                loginSignupFlow: 'chooseLoginOrSignup',
                settingsLogin: null,
                voucherChosen: false,
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('finish');
            this.$event_bus.$off('signMeOut');
            this.$event_bus.$off('codeSent');
            this.$event_bus.$off('booking-restart');
        },

        mounted: function () {
            this.setCurrentModule(bookingModules.BOOK_VOUCHER);

            this.$event_bus.$on('finish', (data) => {
                this.showConfirmation = true;
            });

            this.$event_bus.$on('signMeOut', () => {
                this.signOutAlert = true;
            });

            this.$event_bus.$on('booking-restart', () => {
                this.showConfirmation = false;
            });

            this.$event_bus.$on('LoadData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;

                if (this.settingsLogin && this.settingsLogin.allow_create === 0) {
                    this.loginSignupFlow = 'login'
                }
            });

            this.$event_bus.$on('goLogin', () => {
                this.loginSignupFlow = 'login';
            });

            this.$event_bus.$on('goSignUp', () => {
                this.loginSignupFlow = 'signUp';
            });

            this.$event_bus.$on('goLoginOrSignUp', () => {
                this.loginSignupFlow = (this.chooseFromLogin) ? 'login' : 'signUp';

            });

            this.$event_bus.$on('codeSent', (data) => {
                this.loginSignupFlow = 'loginCode';
                this.$event_bus.$emit('codeSent2', data);
            });

            this.$event_bus.$on('chooseLoginUser', (data) => {
                this.loginSignupFlow = 'chooseLoginUser';
                this.$event_bus.$emit('chooseLoginUser2', data);
            });

            this.$event_bus.$on('goBackToChoose', () => {
                this.loginSignupFlow = 'chooseLoginOrSignup';
            });

            this.$event_bus.$on('beforeCode', function(beforeCodeValue) {
                this.chooseFromLogin = beforeCodeValue === 'login';}.bind(this));

            this.$event_bus.$on('voucherClicked', (voucher) => {
                this.voucherChosen = true;
            });

            this.init();
        },

        components: {
            FillInformation: FillInformation,
            VoucherPurchaseSuccess: VoucherPurchaseSuccess,
            Login: Login,
            LoginCode: LoginCode,
            ChooseLoginUser: ChooseLoginUser,
            ChooseUser: ChooseUser,
            ChooseVoucher: ChooseVoucher,
            Payment: Payment,
            ConfirmBooking: ConfirmBooking,
            SignUp: SignUp,
            ChooseLoginOrSignup: ChooseLoginOrSignup,
            OnlineBookingSidebarSteps: OnlineBookingSidebarSteps,
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentModule']),
            init: function () {
                this.loading = true;

                this.$store.commit('clearProducts');

                http.get('/book/' + this.permalink + "/get")
                    .then(({data}) => {
                        this.online_booking_settings = data.online_booking_settings;
                        this.user = data.user;
                        this.gmaps_url = data.gmaps_url;
                        this.logged_in_client = data.logged_in_client;

                        if (data.settings_login) {
                            this.loginDesc = data.settings_login.description;
                        }

                        this.$event_bus.$emit('LoadData', data);

                        if (data.settings_login.active && data.settings_login.require_login && !this.logged_in_client) {
                            this.requiredLogin = true;
                        }

                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            toggleParagraph: function (e) {
                $(".expanding-p").toggleClass("expanding-p-expanded");
                $("#chevron").toggleClass("zmdi-chevron-up");
            }
        },

        updated: function () {
            this.paragraphHeight = $('#expanding-p').height();
            if (this.paragraphHeight < 70) {
                $("#chevron").hide();
                $("#expanding-p").addClass("expanding-p-nogradient");
            }
        },
    };
</script>

<template>
    <div>
        <div class="text-center" v-if="loading">
            <div class="preloader"></div>
        </div>

        <div v-show="!loading">
            <div class="row">
                <online-booking-sidebar-steps
                    class="col-md-4"
                    v-show="!showConfirmation"
                    :title="trans('online_booking.vouchers.title')"
                />
                <div
                    class="panel-group col-md-8"
                    id="booking-accordion"
                    role="tablist"
                    aria-multiselectable="false"
                    v-show="!showConfirmation"
                >
                    <choose-voucher :permalink="permalink"></choose-voucher>
                    <fill-information v-if="!requiredLogin"></fill-information>
                    <choose-user v-if="!requiredLogin"></choose-user>
                    <confirm-booking v-if="!requiredLogin"></confirm-booking>
                    <payment v-if="!requiredLogin"></payment>
                </div>
            </div>

            <transition name="slideUpConfirm">
                <voucher-purchase-success v-show="!requiredLogin && showConfirmation"></voucher-purchase-success>
            </transition>
        </div>

        <div v-show="requiredLogin && !loading && voucherChosen">
            <!-- Alert - Login required -->
            <div class="row">
                <div class="col-sm-8 col-sm-offset-2">
                    <ep-banner class="mb-6">
                        <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                        <span>{{ trans('vouchers.need_login') }}</span>
                    </ep-banner>
                </div>
            </div>
            <!-- End of alert -->

            <!-- Alert - Login Description -->
            <div class="row" v-if="loginDesc">
                <div class="col-sm-8 col-sm-offset-2">
                    <div class="jumbotron-login m-b-20">
                        <span v-sanitize-html="loginDesc"></span>
                    </div>
                </div>
            </div>
            <!-- End of alert -->

            <transition-group name="slideUp" mode="out-in">
                <choose-login-or-signup
                    key="choose-login-or-signup"
                    v-show="loginSignupFlow === 'chooseLoginOrSignup' && settingsLogin && settingsLogin.allow_create"
                ></choose-login-or-signup>
                <login key="login" v-show="loginSignupFlow === 'login'"></login>
                <login-code key="login-code" v-show="loginSignupFlow === 'loginCode'"></login-code>
                <choose-login-user
                    :choose-from-login="true"
                    key="choose-login-user"
                    v-show="loginSignupFlow === 'chooseLoginUser'"
                ></choose-login-user>
                <sign-up key="signup" v-show="loginSignupFlow === 'signUp'" class="row"></sign-up>
            </transition-group>
        </div>
    </div>
</template>
